module.exports = __webpack_public_path__ + "static/media/icons8-amazon-web-services.4ad8d13a.svg";